<template>
  <div class="app-config-reward">
    <div class="header-process">
      <span>事件码:</span>
      <el-select v-model="searchForm.eventCode" placeholder="请选择">
        <el-option v-for="item in otherOptions.eventList" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <span>状态:</span>
      <el-select v-model="searchForm.valid" placeholder="请选择">
        <el-option v-for="item in otherOptions.validList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <span>奖励类型:</span>
      <el-select v-model="searchForm.awardType" placeholder="请选择" filterable>
        <el-option label="ALL" :value="0"></el-option>
        <el-option v-for="item in otherOptions.awardTypeList" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="queryAppList(true)">查询</el-button>
      <el-button type="success" @click="addDialogShow">新增</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="奖品id"></el-table-column>
      <el-table-column prop="eventCode" label="事件码">
        <template slot-scope='scope'>
          {{ getCurItemName(otherOptions.eventList, scope.row.eventCode) }}
        </template>
      </el-table-column>
      <el-table-column prop="awardType" label="奖励类型">
        <template slot-scope='scope'>
          {{ getCurItemName(otherOptions.awardTypeList, scope.row.awardType) }}
        </template>
      </el-table-column>
      <el-table-column prop="dataId" label="奖励关联id"></el-table-column>
      <el-table-column prop="name" label="奖励名称"></el-table-column>
      <el-table-column prop="icon" label="图标">
        <template slot-scope='scope'>
          <img style="width: 50px;" :src="scope.row.icon" alt="图标">
        </template>
      </el-table-column>
      <el-table-column prop="bigIcon" label="大图标">
        <template slot-scope='scope'>
          <img style="width: 50px;" :src="scope.row.bigIcon" alt="大图标">
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" label="单个奖品价值"></el-table-column>
      <el-table-column prop="awardDesc" label="奖品描述"></el-table-column>
      <el-table-column prop="valid" label="是否有效">
        <template slot-scope='scope'>
          {{ scope.row.valid === 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间">
        <template slot-scope='scope'>
          {{ formatTimeStamp(scope.row.ctime, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="mtime" label="修改时间">
        <template slot-scope='scope'>
          {{ formatTimeStamp(scope.row.mtime, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column prop="operator" label="操作">
        <template slot-scope='scope'>
          <el-button @click="editDialogShow(scope.row)" type="primary" size="small" icon="el-icon-edit">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="searchForm.page"
      @current-change="queryAppList(false)">
    </el-pagination>
    <el-drawer :title="dialogData.isEdit ? '编辑' : '新增'" :visible.sync="dialogData.visible"
      :before-close="closeDialogHandle">
      <div class="drawer-content">
        <el-form ref="form" :model="dialogData.processData" label-width="90px">
          <el-form-item label="事件码">
            <el-select v-model="dialogData.processData.eventCode" placeholder="请选择事件码">
              <el-option v-for="item in otherOptions.eventList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="奖励类型">
            <el-select v-model="dialogData.processData.awardType" placeholder="请选择奖励类型">
              <el-option v-for="item in otherOptions.awardTypeList" :key="item.value" :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="奖励关联id">
            <el-input v-model="dialogData.processData.dataId" class="dialog-input"></el-input>
          </el-form-item>
          <el-form-item label="英文名称">
            <el-input v-model="dialogData.processData.name" class="dialog-input"></el-input>
          </el-form-item>
          <el-form-item label="单个奖品价值">
            <el-input v-model="dialogData.processData.unitPrice" class="dialog-input"></el-input>
          </el-form-item>
          <el-form-item label="图标">
            <UploadSingleImg v-model="dialogData.processData.icon" :on-upload="uploadFile" />
          </el-form-item>
          <el-form-item label="大图标">
            <UploadSingleImg v-model="dialogData.processData.bigIcon" :on-upload="uploadFile" />
          </el-form-item>
          <el-form-item label="是否有效">
            <el-radio-group v-model="dialogData.processData.valid">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖品描述">
            <el-input type="textarea" v-model="dialogData.processData.awardDesc" class="dialog-input"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closeDialogHandle">取 消</el-button>
          <el-button type="primary" @click="submitDialogData" :loading="dialogData.loading">{{ dialogData.loading ? `提交中
            ...` : '确 定' }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getConstList } from '@/api/constRequest'
import { getConfigList, createAppConfig, updateAppConfig } from '@/api/rewardConfigRequest'
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg'
import { formatTimeStamp } from '@/utils/common'
export default {
  components: {
    UploadSingleImg
  },
  data() {
    return {
      otherOptions: {
        eventList: [],
        validList: [
          { value: -1, label: 'ALL' },
          { value: 0, label: '无效' },
          { value: 1, label: '有效' },
        ],
        awardTypeList: []
      },
      searchForm: {
        eventCode: 0,
        valid: -1,
        awardType: 0,
        page: 1
      },
      tableData: [],
      total: 0,
      dialogData: {
        loading: false,
        visible: false,
        processData: {
          eventCode: 0,
          valid: 1,
          awardType: 0,
          dataId: '',
          name: '',
          icon: '',
          bigIcon: '',
          unitPrice: '',
          awardDesc: ''
        },
        isEdit: false
      }
    }

  },
  methods: {
    // 格式化时间
    formatTimeStamp,
    // 获取常量列表名称
    getCurItemName(list, value) {
      if (!list || list.length === 0) return ''
      const item = list.find(item => item.value === value)
      return item ? item.name : ''
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'rewards/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    // 查询数据 isSearch true 跳到第一页
    async queryAppList(isSearch) {
      if (isSearch) this.searchForm.page = 1
      const res = await getConfigList(this.searchForm)
      if (res.code !== 0) return this.$message.error(res.msg)
      this.tableData = res.data.data
      this.total = res.data.total
      this.$message.success('success')
    },
    // 获取所有常量列表
    async getAllConst() {
      const resEve = await getConstList('eventCode')
      if (resEve.code !== 0) return this.$message.error(resEve.msg)
      this.otherOptions.eventList = resEve.data
      const resType = await getConstList('awardType')
      if (resType.code !== 0) return this.$message.error(resType.msg)
      this.otherOptions.awardTypeList = resType.data
      this.dialogData.processData.awardType = this.otherOptions.awardTypeList[0].value
    },
    // 新增窗口打开
    addDialogShow() {
      this.dialogData.visible = true
      this.dialogData.isEdit = false
      this.dialogData.processData = {
        eventCode: 0,
        valid: 1,
        awardType: this.otherOptions.awardTypeList[0].value,
        dataId: '',
        name: '',
        icon: '',
        bigIcon: '',
        unitPrice: '',
        awardDesc: ''
      }
    },
    // 编辑窗口打开
    editDialogShow(row) {
      this.dialogData.processData = JSON.parse(JSON.stringify(row))
      this.dialogData.isEdit = true
      this.dialogData.visible = true
    },
    // 关闭窗口
    closeDialogHandle() {
      this.dialogData.visible = false
    },
    // 0 add, 1 edit, 提交修改，新增数据
    async submitDialogData() {
      this.dialogData.loading = true
      let res = null
      if (this.dialogData.isEdit) {
        res = await updateAppConfig(this.dialogData.processData)
      } else {
        res = await createAppConfig(this.dialogData.processData)
      }
      if (res.code !== 0) {
        this.$message.error(res.msg)
      } else {
        this.$message.success('update success')
        this.queryAppList(!this.dialogData.isEdit)
      }
      this.dialogData.loading = false
      this.closeDialogHandle()
    }
  },
  mounted() {
    this.getAllConst()
    this.queryAppList(true)
  }
}


</script>
<style scoped lang="scss">
.el-select {
  margin: 0 10px;
}

.dialog-input {
  width: 217px;
  margin-left: 10px;
}

.drawer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .el-form {
    flex-grow: 1;
  }
}

.demo-drawer__footer {
  display: flex;

  >* {
    flex-grow: 1;
  }
}
</style>